import { colors } from './../../../config/styles'
import images from './../../../config/images'

export default {
	container:{

	},
	header:{
		width 				: '100%',
		height 				: 650,
		backgroundImage 	: `url(${images.homeHeader})`,
		backgroundSize 		: 'cover',
		backgroundPosition 	: 'center',
		backgroundRepeat	: 'no-repeat',
		display 			: 'flex',
		flexDirection 		: 'column',
		alignItems 			: 'center',
		justifyContent 		: 'center',

		'@media (max-width: 1000px)' : {
			height 				: 600,
		},
		'@media (max-width: 800px)' : {
			height 				: 500,
		},
		'@media (max-width: 600px)' : {
			height 				: 400,
		},
		'@media (max-width: 450px)' : {
			height 				: 'auto',
			paddingTop 			: 80,
			paddingBottom 		: 80,
		},
	},
	headerTitle:{
		textAlign 		: 'center',
		color 			: colors.red,
		fontSize 		: 84,
		letterSpacing 	: 4,
		lineHeight 		: 1.2,
		marginTop 		: 0,
		marginBottom 	: 50,
		fontWeight 		: 500,

		'@media (max-width: 1000px)' : {
			fontSize 		: 72,
			lineHeight 		: 1.1,
			marginBottom 	: 40,
		},
		'@media (max-width: 800px)' : {
			fontSize 		: 56,
			lineHeight 		: 1.1,
			marginBottom 	: 30,
		},
		'@media (max-width: 600px)' : {
			fontSize 		: 38,
			lineHeight 		: 1.1,
			marginBottom 	: 20,
		},
		'@media (max-width: 450px)' : {
			fontSize 		: 28,
			lineHeight 		: 1.1,
			marginBottom 	: 15,
		},

	},
	headerLink: {
		display 			: 'inline-block',
		padding 			: '15px 25px',
		fontSize 			: 20,
		color 				: colors.white,
		backgroundColor 	: colors.red,
		textDecoration 		: 'none',
		border				: `1px solid ${colors.red}`,
		fontWeight 			: 300,

		transition 			: 'color 0.2s ease-in, background-color 0.2s ease-in',
		':hover': {
			color 			: colors.red,
			backgroundColor : colors.white,
		},

		'@media (max-width: 1000px)' : {
			padding 			: '12px 24px',
			fontSize 			: 20,
		},
		'@media (max-width: 800px)' : {
			padding 			: '10px 20px',
			fontSize 			: 18,
		},
		'@media (max-width: 600px)' : {
			padding 			: '8px 16px',
			fontSize 			: 16,
		},
		'@media (max-width: 450px)' : {
			padding 			: '6px 12px',
			fontSize 			: 14,
		},
	},

	whatWeDoContainer: {
		backgroundColor 	: colors.red,
		backgroundImage 	: `radial-gradient(${colors.lightRed} 0%, ${colors.red} 40%)`,
		paddingTop 			: 100,
		paddingBottom 		: 100,
		textAlign 			: 'center',
		paddingRight 		: 30,
		paddingLeft 		: 30,

		'@media (max-width: 1000px)' : {
			paddingTop 			: 90,
			paddingBottom 		: 90,
		},
		'@media (max-width: 800px)' : {
			paddingTop 			: 80,
			paddingBottom 		: 80,
		},
		'@media (max-width: 600px)' : {
			paddingTop 			: 70,
			paddingBottom 		: 70,
		},
		'@media (max-width: 450px)' : {
			paddingTop 			: 60,
			paddingBottom 		: 60,
			paddingRight 		: 20,
			paddingLeft 		: 20,
		},
	},
	whatWeDoTitle: {
		color 				: colors.white,
		marginTop 			: 0,
		marginBottom 		: 40,
		fontSize 			: 46,
		textTransform 		: 'uppercase',
		letterSpacing 		: 4,

		'@media (max-width: 1000px)' : {
			fontSize 			: 40,
		},
		'@media (max-width: 800px)' : {
			fontSize 			: 36,
		},
		'@media (max-width: 600px)' : {
			fontSize 			: 30,
			marginBottom 		: 30,
		},
		'@media (max-width: 450px)' : {
			fontSize 			: 26,
			marginBottom 		: 20,
		},
	},
	starWrapper: {
		width 				: 40,
		marginBottom 		: 40,
		fill 				: colors.white,
		display 			: 'inline-block',
		fontSize 			: 0,

		'@media (max-width: 600px)' : {
			width 				: 30,
			marginBottom 		: 30,
		},
		'@media (max-width: 450px)' : {
			width 				: 20,
			marginBottom 		: 20,
		},
	},
	star: {
		width 				: '100%'
	},
	whatWeDoCopy: {
		margin 				: '0px auto',
		maxWidth 			: 650,
		fontSize 			: 22,
		color 				: colors.white,
		lineHeight 			: 1.5,
		fontWeight 			: 300,

		'@media (max-width: 1000px)' : {
			fontSize 			: 22,
		},
		'@media (max-width: 800px)' : {
			fontSize 			: 20,
		},
		'@media (max-width: 600px)' : {
			fontSize 			: 18,
		},
		'@media (max-width: 450px)' : {
			fontSize 			: 16,
		},
	},

	servicesContainer: {
		backgroundColor 	: colors.gray,
		display 			: 'flex',
		flexWrap 			: 'wrap',
		justifyContent 		: 'space-around',
		paddingTop 			: 60,
		paddingBottom 		: 30,
		paddingLeft 		: 30,
		paddingRight 		: 30,
	},
	service: {
		textAlign 			: 'center',
		width 				: '14%',
		paddingLeft 		: 15,
		paddingRight 		: 15,
		minWidth 			: 120,
		marginBottom 		: 30,
	},
	serviceIconWrapper: {
		display 			: 'inline-block',
		width 				: 50,
		marginBottom 		: 10,
		fontSize 			: 0,
		fill 				: colors.red,
		height 				: 60,
	},
	serviceIcon: {
		width 			: '100%'
	},
	serviceTitle: {
		fontSize 		: 16,
		lineHeight 		: 1.25,
		color 			: colors.red,
		margin 			: 0,
		fontWeight 		: 300,
	},

	mapContainer: {
		paddingLeft 	: '15%',
		paddingTop 		: 100,
		paddingBottom 	: 100,

		'@media (max-width: 600px)' : {
			paddingLeft 	: 0,
			textAlign		: 'center',
		},
	},
	mapWrapper: {
		position 		: 'absolute',
		width 			: '60%',
		left 			: '35%',
		fontSize 		: 0,

		'@media (max-width: 600px)' : {
			position 		: 'relative',
			width 			: '90%',
			left 			: '5%',
			marginBottom 	: 30,
		},
	},
	map: {
		width 			: '100%',
	},
	mapTitle: {
		fontSize 		: 120,
		color 			: colors.red,
		lineHeight 		: 0.9,
		marginTop 		: 0,
		marginBottom 	: 30,

		'@media (max-width: 1000px)' : {
			fontSize 		: 90,
		},
		'@media (max-width: 800px)' : {
			fontSize 		: 60,
		},
		'@media (max-width: 600px)' : {
			display 		: 'none',
		},
	},
	mapTitleMobile: {
		fontSize 		: 40,
		color 			: colors.red,
		lineHeight 		: 0.9,
		marginTop 		: 0,
		marginBottom 	: 30,
		textAlign 		: 'center',
		display 		: 'none',

		'@media (max-width: 600px)' : {
			display 		: 'block',
		},
		'@media (max-width: 450px)' : {
			fontSize 		: 28,
		},
	},
	mapLink: {
		display 			: 'inline-block',
		padding 			: '15px 25px',
		fontSize 			: 20,
		color 				: colors.white,
		backgroundColor 	: colors.red,
		textDecoration 		: 'none',
		border				: `1px solid ${colors.red}`,

		transition 			: 'color 0.2s ease-in, background-color 0.2s ease-in',
		':hover': {
			color 			: colors.red,
			backgroundColor : colors.white,
		},

		'@media (max-width: 1000px)' : {
			padding 			: '12px 24px',
			fontSize 			: 20,
		},
		'@media (max-width: 800px)' : {
			padding 			: '10px 20px',
			fontSize 			: 18,
		},
		'@media (max-width: 600px)' : {
			padding 			: '8px 16px',
			fontSize 			: 16,
		},
		'@media (max-width: 450px)' : {
			padding 			: '6px 12px',
			fontSize 			: 14,
		},
	},
}



// WEBPACK FOOTER //
// ./src/pages/Front/Home/styles.js